import React from 'react'

const MailsStatsScreen = () => {
    return (
        <div>MailsStatsScreen</div>
    )
}

export default MailsStatsScreen